import { useEffect, useCallback, useRef } from 'react';
import { useDebounce } from '@clover-util/use-debounce';
export function useDebouncedEffect(effect, waitOrSettingsOrDeps, deps = []) {
    const cleaner = useRef();
    const invokeCleaner = useCallback(() => {
        if (cleaner.current)
            cleaner.current();
    }, []);
    const debounced = useDebounce(() => {
        invokeCleaner();
        cleaner.current = effect();
    }, waitOrSettingsOrDeps, deps);
    useEffect(() => {
        debounced();
        return invokeCleaner;
    }, [debounced, invokeCleaner]);
}
//# sourceMappingURL=useDebouncedEffect.js.map